// extracted by mini-css-extract-plugin
export default {"card":"LoadPortFolio_card__Borgb","crd_title":"LoadPortFolio_crd_title__rplBe","img_wrapper":"LoadPortFolio_img_wrapper__PgHO4","btn_order":"LoadPortFolio_btn_order__RfSdY"};